export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/lofi.9723d2d.svg";